import { PropsWithChildren } from "react";
import Form from "../components/forms/Form";
import Footer from "../components/footer/Footer";
import EditorTracker, {
  EditorAction
} from "../components/editor/EditorTracker";
import useEditorSections from "../components/editor/useEditorSections";
import { FieldValues } from "react-hook-form";

const EditorLayout = <T extends FieldValues>({
  defaultValues,
  actions,
  children,
  onSubmit,
  hideFooter
}: PropsWithChildren<{
  defaultValues: T;
  actions: EditorAction<T>[];
  onSubmit: (data: T) => void;
  hideFooter?: boolean;
}>) => {
  const sections = useEditorSections(children);

  return (
    <div className="flex flex-col bg-ctb-grey-250">
      <Form
        defaultValues={defaultValues}
        onSubmit={onSubmit}
        className="w-full"
        defaultErrorDisplay={false}
      >
        {children}
        {/* EditorTracker (right bar) intentionally hidden for creation step design */}
      </Form>
      {!hideFooter && <Footer />}
    </div>
  );
};

export default EditorLayout;
